import config from 'crm/config'

const customerApi = `${config.apiHost}/oem-customer`

const profileApi = `${config.apiHost}/oem-profile`

export default {
    getGroupList: {
        url: `${customerApi}/api/group_chat/search`,
        type: 'POST',
    },
    getGroupOwnerList: {
        url: `${customerApi}/api/group_chat/owner_list`,
        type: 'GET',
    },
    editGroupInfo: {
        url: `${customerApi}/api/group_chat/{id}/ext`,
        type: 'PUT',
    },
    // 获取群成员
    getGroupMembers: {
        url: `${config.apiHost}/oem-customer-java/api/group_chat/{id}/member/search`,
        type: 'GET',
    },
    // 获取群详情
    getGroupDetails: {
        url: `${customerApi}/api/group_chat/{id}`,
        type: 'GET',
    },
    // 获取群中的统计
    getGroupStat: {
        url: `${customerApi}/api/group_chat/{id}/summary`,
        type: 'GET',
    },
    downloadTemplate: {
        url: `${profileApi}/api/community_qrcode/demo.xlsx`,
        type: 'GET',
    },
    importGroupLink: {
        url: `${profileApi}/api/community_qrcode/import`,
        type: 'POST',
    },
    communityQrcode: {
        url: `${profileApi}/api/community_qrcode`,
        type: 'GET',
    },
    tasks: {
        url: `${profileApi}/api/tasks/{task_id}`,
        type: 'GET',
    },
    exportListData: {
        url: `${customerApi}/api/group_chat/export`,
        type: 'POST',
    },
}
